import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';
import { useNavigate } from 'react-router-dom';

export const MerchantContext = createContext();

export function MerchantContextProvider({ children }) {
    const { user } = useContext(CommonContext);

    const [addModal, setAddModal] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [viewData, setViewData] = useState('');
    const [allData, setAllData] = useState([]);
    const [allMerchant, setAllMerchant] = useState([]);
    const [allSignupMerchant, setAllSignupMerchant] = useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMesaage, setAlertMesaage] = useState('');
    const [severity, setSeverity] = useState('');
    const [filters, setFilters] = useState({
        filterType: 'brand name',
        searchValue: '',
        status: 'all',
    });
    const navigate = useNavigate();
    const onCloseAlert = () => {
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('')
    };
    const handleAddModals = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setViewData('');
        setIsEdit(false);
        setAddModal(false);
    };
    const onLoadApi = () => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id }
        } else {
            postReq = { admin_id: user?.id }
        }
        setFirstLoading(false);
        commonApi.post('/merchant/list', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllMerchant(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onSignupLoadApi = () => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id }
        } else {
            postReq = { admin_id: user?.id }
        }
        setAllSignupMerchant([]);
        setFirstLoading(false);
        commonApi.post('/signup/list', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllSignupMerchant(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onExport = () => {
        const payload = { ...filters };

        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id;
        }
        if (payload.status === 'all') {
            payload.status = '';
        }
        setIsLoading(true);
        commonApi.post('/merchant/export', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMesaage(error?.response?.data?.msg);
                setSeverity('error')
            });
    };
    useEffect(() => {
        onLoadApi();
    }, []);


    // You can provide any values or functions you want to make available to consumers here
    const contextValue = {
        onSignupLoadApi,
        allSignupMerchant,
        setAllSignupMerchant,
        setFilters,
        filters,
        onExport,
        onCloseAlert,
        severity,
        alertMesaage,
        openAlert,
        isEdit,
        onLoadApi,
        isLoading,
        firstLoading,
        viewData,
        allData,
        allMerchant,
        handleAddModals,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllMerchant,
        setAllData,
        setViewData,
        setFirstLoading,
        setIsLoading,
        setIsEdit,
        setSeverity,
        setAlertMesaage,
        setOpenAlert,
    };

    // Render the provider with children
    return <MerchantContext.Provider value={contextValue}>{children}</MerchantContext.Provider>;
}
